/* eslint-disable no-nested-ternary */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable import/no-named-as-default-member */
import React, { useState, useEffect } from 'react';
import { Avatar, Card, Direction, Column, SubHeading, TextSmall } from '@scotia/canvas-react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { getInStorage, saveInStorage } from '@cldf/scotiaweb-web-storage';
import { getAllInSession } from '@cldf/scotiaweb-customer-information';
import { getCustomerInformation } from '../../services';
import Iframe from 'react-iframe';
import custom from './wellcome.scss';
import Error from '../error';
import { SummaryContextMenu } from '../../components/summary/ProductSummary/components/SummaryContextMenu';
import { Shortcuts } from '../../components/shortcuts';
import { getClientRut, getAvatarRendererUrl, getHomeScotiaLevelsUrl } from '../../services/service.parameters';

const CUSTOMER_INFORMATION_KEY = 'customer_info';

export const CustomAvatar = ({ error, name, lastName }) => {
  if (error) return null;
  return (
    <Column xs={2} className={custom['avatar-container']}>
      {name && lastName ? (
        <Avatar size={60} firstName={name} lastName={lastName} />
      ) : (
        <Skeleton circle height={60} width={60} />
      )}
    </Column>
  );
};

CustomAvatar.displayName = 'CustomAvatar';

export const WellComeMessage = ({ error, lastName, name, gender, lastConnectionDate, callBack }) => {
  if (!error) {
    return (
      <React.Fragment>
        <Column xs={12} className={custom['wellcome-div-align']}>
          {name && lastName && gender ? (
            <SubHeading id="wellcome">{`Bienvenid${
              gender && gender === 'F' ? 'a' : 'o'
            } ${name} ${lastName}`}</SubHeading>
          ) : (
            <Skeleton width={'100%'} />
          )}
        </Column>
        <Column xs={12} md={12} className={custom['wellcome-div-align']} id="last-date">
          {lastConnectionDate && <TextSmall>{lastConnectionDate}</TextSmall>}
        </Column>
      </React.Fragment>
    );
  }
  return <Error actionClick={callBack} error border={false} reduced />;
};

WellComeMessage.displayName = 'WellComeMessage';

export const StateLessCustomerWellcomeCard = ({
  rut,
  gender,
  name = '',
  lastName = '',
  lastConnectionDate,
  error,
  callBack,
  avatarRendererUrl,
  homeScotiaLevelsUrl,
}) => (
  <Card style={{ padding: '2.4rem' }}>
    <Direction>
      <Column xs={6} md={6} style={{ borderRight: '1px solid #e0e9ef', paddingLeft: '0' }}>
        {!error ? (
          rut && name && lastName ? (
            <renderer-loader src={avatarRendererUrl} props={JSON.stringify({ firstName: name, lastName, rut })} />
          ) : (
            <Direction>
              <CustomAvatar error={error} name={name} lastName={lastName} />
              <Column xs={10} style={{ padding: '0' }}>
                <Direction className={custom['wellcome-full-height']}>
                  <Column xs={12} className={custom['wellcome-div-align']}>
                    {name && lastName && gender ? (
                      <SubHeading>{`Bienvenid${gender && gender === 'F' ? 'a' : 'o'} ${name} ${lastName}`}</SubHeading>
                    ) : (
                      <Skeleton width={'100%'} />
                    )}
                  </Column>
                  <Column xs={12} md={12} className={custom['wellcome-div-align']}>
                    {lastConnectionDate && <TextSmall>{lastConnectionDate}</TextSmall>}
                  </Column>
                </Direction>
              </Column>
            </Direction>
          )
        ) : (
          <Direction className={custom['wellcome-full-height']}>
            <WellComeMessage
              error={error}
              name={name}
              lastName={lastName}
              gender={gender}
              lastConnectionDate={lastConnectionDate}
              callBack={callBack}
            />
          </Direction>
        )}
      </Column>
      <Column md={6}>
        {homeScotiaLevelsUrl && (
          <Iframe url={homeScotiaLevelsUrl} scrolling="no" display="block" width="100%" height="90px"/>
        )}
        <div
          style={{
            position: 'absolute',
            top: -15,
            right: -20,
          }}
        >
          <SummaryContextMenu productType={'user'} opt1 opt2 />
        </div>
      </Column>
      <Direction>
        <Shortcuts rut={rut} />
      </Direction>
    </Direction>
  </Card>
);

StateLessCustomerWellcomeCard.displayName = 'StateLessCustomerWellcomeCard';

export const CustomerWellcomeCard = () => {
  const [name, setName] = useState(null);
  const [gender, setGender] = useState('M');
  const [rut, setRut] = useState('');
  const [avatarRendererUrl, setAvatarRendererUrl] = useState('');
  const [homeScotiaLevelsUrl, setHomeScotiaLevelsUrl] = useState('');
  const [lastName, setLastName] = useState(null);
  const [lastConnectionDate, setLastConnectionDate] = useState(null);
  const [error, setError] = useState(false);

  const capitalizeName = theName => theName.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());

  /* istanbul ignore next */
  const callCustomerService = () => {
    setError(false);
    getCustomerInformation()
      .then(resp => {
        const data = resp.data.data;
        saveInStorage(CUSTOMER_INFORMATION_KEY, data, {
          inSession: false,
          expires: false,
          expiration_date: null,
        });

        setName(data.name);
        setGender(data.gender);
        setLastName(data.lastName);
        setLastConnectionDate(null);
      })
      .catch(() => {
        setError(true);
      });
  };

  /* istanbul ignore next */
  useEffect(() => {
    const _inStorageConfig = { inSession: false };
    Promise.all([
      getClientRut(),
      getInStorage(CUSTOMER_INFORMATION_KEY, _inStorageConfig),
      getAllInSession(),
      getAvatarRendererUrl(),
      getHomeScotiaLevelsUrl(),
    ])
      .then(([_rut, customerInfo, resp, _avatarRendererUrl, _homeScotiaLevelsUrl]) => {
        if (true) {
          setAvatarRendererUrl(_avatarRendererUrl);
          setHomeScotiaLevelsUrl(_homeScotiaLevelsUrl);
          setRut(_rut);
        }
        /* istanbul ignore if */
        if (customerInfo) {
          setName(customerInfo.name);
          setGender(customerInfo.gender);
          setLastName(customerInfo.lastName);
          setLastConnectionDate(null);
        } else callCustomerService();
      })
      .catch(error => {
        console.log('Get user info error: ', error);
      });
  }, []);

  return (
    <div className={'canvas'}>
      <StateLessCustomerWellcomeCard
        rut={rut}
        avatarRendererUrl={avatarRendererUrl}
        homeScotiaLevelsUrl={homeScotiaLevelsUrl}
        name={name ? capitalizeName(name.split(' ')[0]) : null}
        gender={gender}
        lastName={name && lastName ? capitalizeName(name.split(' ').length > 1 ? name.split(' ')[1] : lastName) : null}
        lastConnectionDate={lastConnectionDate}
        callBack={callCustomerService}
        error={error}
      />
    </div>
  );
};

CustomerWellcomeCard.displayName = 'CustomerWellcomeCard';

StateLessCustomerWellcomeCard.propTypes = {
  rut: PropTypes.string.isRequired,
  gender: PropTypes.string,
  // name: PropTypes.string.isRequired,
  // lastName: PropTypes.string.isRequired,
  lastConnectionDate: PropTypes.string,
};

StateLessCustomerWellcomeCard.defaultProps = {
  gender: 'M',
  lastConnectionDate: null,
};
